module.exports = __webpack_public_path__ + "static/img/number08.2cf66107.png";